import { z } from "zod";
import { UserSchema } from "../../models/user.schema";

export const PrivateUserControllerResponseSchema = {
  getUserByEmail: UserSchema.nullable(),

  createMyUser: UserSchema,

  createNewUser: UserSchema,

  mailWelcome: z.boolean(),

  mailNewUser: z.boolean(),

  getUser: UserSchema.nullable(),

  updateUser: UserSchema,
};
